export default "__VITE_ASSET__DVyNiQdL__"